import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, getTestId, isValidObject, RightChevronIcon, Typography, useBreakpoint } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { getIngressCardWidgetStyles, getThemeColors } from '../../IngressCardWidgetStyles';
import { IngressImage } from '../ingress-image/IngressImage';
import { Score } from '../score/';
export var Compact = props => {
  var _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    imageUrl = props.imageUrl,
    title = props.title,
    description = props.description,
    _props$ingressCardThe = props.ingressCardTheme,
    ingressCardTheme = _props$ingressCardThe === void 0 ? 'default' : _props$ingressCardThe,
    ctaText = props.ctaText,
    onCtaPressMetaData = props.onCtaPressMetaData,
    onUserAction = props.onUserAction,
    _props$actionType = props.actionType,
    actionType = _props$actionType === void 0 ? 'none' : _props$actionType,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'IngressCardWidget' : _props$testID,
    actionProps = props.actionProps,
    scoreProps = props.scoreProps;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var ingressCardWidgetStyles = getIngressCardWidgetStyles(props, isLargeScreen);
  var ingressCardColors = getThemeColors(ingressCardTheme);
  var Wrapper = actionType == 'chevron' ? Pressable : View;
  return _jsx(Wrapper, Object.assign({}, actionType == 'chevron' && {
    onPress: () => {
      onCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onCtaPressMetaData), Object.assign({}, props)));
    }
  }, getTestId(testID, 'chevron'), {
    style: [ingressCardWidgetStyles.containerPadding, {
      backgroundColor: ingressCardColors.cardBackgroundColor
    }]
  }, {
    children: _jsxs(View, Object.assign({
      style: ingressCardWidgetStyles.container
    }, {
      children: [_jsxs(View, Object.assign({
        style: ingressCardWidgetStyles.iconImage
      }, {
        children: [_jsx(IngressImage, {
          imageUrl: imageUrl,
          testID: testID,
          width: isLargeScreen ? 72 : 56,
          height: isLargeScreen ? 72 : 56
        }), isValidObject(scoreProps) && _jsx(Score, Object.assign({}, scoreProps, getTestId(testID, 'Score')))]
      })), _jsxs(View, Object.assign({
        style: ingressCardWidgetStyles.content
      }, {
        children: [!!title && _jsx(Typography, Object.assign({}, getTestId(testID, 'Title'), {
          text: title,
          color: BLACK_900,
          type: "body-para-" + (isLargeScreen ? 'md' : 'sm') + "-bold"
        })), !!description && _jsx(Typography, Object.assign({}, getTestId(testID, 'Description'), {
          text: description,
          color: BLACK_700,
          style: ingressCardWidgetStyles.desc,
          type: "body-para-" + (isLargeScreen ? 'sm' : 'xs')
        })), actionType == 'button' && _jsx(Button, Object.assign({}, getTestId(testID, 'Button'), {
          size: isLargeScreen ? 'md' : 'sm',
          title: ctaText,
          onPress: () => {
            onCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onCtaPressMetaData), Object.assign({}, props)));
          },
          style: [ingressCardWidgetStyles.actionDefault, actionProps === null || actionProps === void 0 ? void 0 : actionProps.style]
        }, actionProps))]
      })), actionType == 'chevron' && _jsx(View, Object.assign({
        style: ingressCardWidgetStyles.chevronItem
      }, {
        children: _jsx(RightChevronIcon, Object.assign({
          fontSize: 24,
          color: BLACK_700
        }, getTestId(testID, 'RightChevronIcon')))
      }))]
    }))
  }));
};